import { Column, ColumnValue, AdobePreviewFileOptions } from '../types'

export const SYSTEM_DATE_KEYS = [
  'installer_visit_date',
  'installation_end_date',
  'deadline',
  'creative_deadline',
  'shipment_date',
  'created_at',
  'updated_at',
]

export const SYSTEM_DATETIME_KEYS = ['installer_visit_date', 'installation_end_date', 'created_at', 'updated_at']

export const ATTACHMENT_KEYS = ['uploads', 'design_files', 'comment_attachments', 'attachments']

export interface CellRendererProps {
  value: ColumnValue
  column: Column
  rowId: number
  timeZone?: string
  adobePreviewFileOptions?: AdobePreviewFileOptions
}
